import axios from '../../axios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/berry-admin/dept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/berry-admin/dept/delete',
        method: 'post',
        data
    })
}
// 查询机构树
export const findDeptTree = () => {
    return axios({
        url: '/berry-admin/dept/findTree',
        method: 'get'
    })
}

// 查询机构树
export const findAll = () => {
  return axios({
    url: '/berry-admin/dept/findAll',
    method: 'get'
  })
}


// 主键查询
export const selectByPrimaryKey = (params) => {
  return axios({
    url: '/berry-admin/dept/select_by_primary_key',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/admin/dept.js